<template>
  <div class="container agencyinfo"
       @scroll="scroll"
       v-if="isLoadOver">

    <div class="detail-box">
      <!-- 单项委托 -->
      <div class="delegate-box" v-if="type == 7 && relevanceId != null">
        <p class="title">单项委托审批</p>
        <p class="sub-title">旅行社单项委托业务描述</p>
        <p class="content">{{ this.delegateContent }}</p>
      </div>
      <div class="delegate-history-box" v-if="type == 7 && relevanceId != null" @click="goDelegateReviewHistory">
        <div class="title-box">
          <img class="icon" src="../../assets/travelAgency/icon_clock.png" alt="">
          <p class="title">单项委托审批历史记录</p>
        </div>
        <img class="arrow-icon" src="../../assets/travelAgency/ic_righticon.png" alt="">
      </div>
      <!-- 注册/审核状态 --> 
      <div class="state-box">
        <div class="state-item-box">
          <p class="state-text" v-if="travelAgencyDetails.state == 1 || travelAgencyDetails.state == 3">已注册</p>
          <p class="state-text" v-else>未注册</p>
        </div>
        <div v-if="travelAgencyDetails.state != 3" class="state-item-box">
          <img class="icon" src="../../assets/travelAgency/icon_upload_gray_circle.png" alt="">
          <p class="state-text">{{ travelAgencyDetails.stateStr }}</p>
        </div>
        <div v-if="travelAgencyDetails.state == 3" class="state-item-box">
          <img class="icon" src="../../assets/travelAgency/icon_check_green_circle.png" alt="">
          <p class="state-text">信息审核通过</p>
        </div>
        <!-- 许可证状态 -->
        <div class="permission-box">
          <p v-if="travelAgencyDetails.travelStatus == 1" class="permission-value green">正常</p>
          <p v-else-if="travelAgencyDetails.travelStatus == 2" class="permission-value red">吊销</p>
          <p v-else-if="travelAgencyDetails.travelStatus == 3" class="permission-value blue">注销</p>
          <p v-else-if="travelAgencyDetails.travelStatus == 4" class="permission-value orange">撤销</p>
        </div>
      </div>
      <!-- 旅行社信息 -->
      <div class="info-box">
        <div class="agency-name-box">
          <img class="agency-logo" :src="travelAgencyDetails.photoPath" alt="">
          <div class="name-box">
            <span class="name-text">{{ travelAgencyDetails.name }}</span>
            <!-- 旅行社类型: 总社/分社/网点 -->
            <span v-if="agencyType[travelAgencyDetails.isParent] != null &&  agencyType[travelAgencyDetails.isParent].length > 0" class="gray-tag">{{ agencyType[travelAgencyDetails.isParent] }}</span>
            <span v-if="travelAgencyDetails.delegationState == 1" class="blue-tag">单项委托</span>
          </div>
        </div>
        <div class="separator"></div>
        <div class="items-box">
          <img v-if="travelAgencyDetails.telephone != null" class="icon_phone" src="../../assets/travelAgency/icon_callphone.png" alt="" @click="onPhoneShow">
          <div v-if="travelAgencyDetails.telephone != null" class="info-item-box">
            <p class="title">电话：</p>
            <p class="content">{{ travelAgencyDetails.telephone }}</p>
          </div>
          <div class="info-item-box">
            <p class="title">所属区域：</p>
            <p class="content">{{ travelAgencyDetails.cityName }}</p>
          </div>
          <div v-if="travelAgencyDetails.address != null" class="info-item-box">
            <p class="title">地址：</p>
            <p class="content">{{ travelAgencyDetails.address }}</p>
          </div>
        </div>
      </div>
    </div>
    
    <card v-if="integrityIndex != null">
      <div class="column mt12"
           @click="$router.push('/travelAgency/integrity?licence='+ travelAgencyDetails.businessLicence)">
        <div class="title">
          <div class="name">
            <rtext :textColor="'#333333'"
                   :textSize="14"
                   style="margin-right:6px;font-weight:700;font-family: PingFang SC,Arial,sans-serif;-webkit-font-smoothing: antialiased;">诚信指数</rtext>
            <div style="margin-top:-1.5px;"
                 class="score-box">{{toFixed(integrityIndex.score,2)}}</div>
          </div>
        </div>
        <right :title="'' + integrityIndex.count + '条扣分记录'"></right>
      </div>
      <rline></rline>
      <div class="column">
        <div class="title">
          <div class="name">
            <rtext :textColor="'#666666'"
                   :textSize="12"
                   style="margin-right:6px">规范: {{integrityIndex.standardScore}}</rtext>
            <rtext :textColor="'#666666'"
                   :textSize="12"
                   style="margin-right:6px">品质: {{integrityIndex.qualityScore}}</rtext>
            <rtext :textColor="'#666666'"
                   :textSize="12"
                   style="margin-right:6px">体验: {{integrityIndex.experienceScore}}</rtext>
          </div>
        </div>
      </div>
    </card>

    <!-- // 重点关注中  "-->
    <card v-if="travelAgencyDetails.isSupervise != 0">
      <div class="column mt12"
           @click="goSuperviseDetail">
        <div class="title">
          <div class="name">
            <rtext :textColor="'#333333'"
                   :textSize="14"
                   style="margin-right:6px;font-weight:700;font-family: PingFang SC,Arial,sans-serif;-webkit-font-smoothing: antialiased;">重点关注中</rtext>
          </div>
        </div>
        <right :title="'监管明细'"></right>
      </div>
      <rline></rline>
      <div class="column">
        <div class="title">
          <div class="name">
            <rtext :textColor="'#666666'"
                   :textSize="12"
                   style="margin-right:6px">{{superviseData.time ? superviseData.time.replace('进入重点监管时间：','').substring(0,16) : ''}}&nbsp;开始</rtext>
          </div>
        </div>
        <rtext :textColor="'#666666'"
               :textSize="12"
               style="margin-right:6px">剩余{{(superviseData.diffDay && superviseData.diffDay != '-')  ? superviseData.diffDay.replace('剩余整改时间：','') : '-天-时-分钟'}}</rtext>
      </div>
    </card>

    <!-- // 黑名单监管中 -->
    <card v-if="travelAgencyDetails.isBlacklist != 0">
      <div class="column mt12"
           @click="$router.push('/travelAgency/blacklist?id=' + travelAgencyDetails.id)">
        <div class="title">
          <div class="name">
            <rtext :textColor="'#333333'"
                   :textSize="14"
                   style="margin-right:6px;font-weight:700;font-family: PingFang SC,Arial,sans-serif;-webkit-font-smoothing: antialiased;">黑名单监管中</rtext>
            <!-- style="display:flex;transform: scale(0.5);transform-origin: left center;" -->
            <!-- <div> -->
            <smllabel :txtColor="'#FFFFFF'"
                      :bgColor="'#FF4D4D'"
                      :borderColor="'#FF4D4D'"
                      v-if="travelAgencyDetails.discipline_type">{{travelAgencyDetails.discipline_type == 'national' ? '全国惩戒' :(travelAgencyDetails.discipline_type == 'provincial'  ? '全省惩戒' : '州市级惩戒') }}</smllabel>
            <!-- </div> -->
          </div>
        </div>
        <right :title="'监管明细'"></right>
      </div>
      <rline></rline>
      <div class="column">
        <div class="title">
          <div class="name">
            <rtext :textColor="'#666666'"
                   :textSize="12"
                   style="margin-right:6px">{{createTime}} 开始</rtext>
          </div>
        </div>
        <rtext :textColor="'#666666'"
               :textSize="12"
               style="margin-right:6px">剩余{{(leftTime && leftTime != '-')  ? leftTime : '-天-时-分钟'}}</rtext>
      </div>
    </card>
    <div class="block-twenty-box"
         style="height:20px;width:100%;"></div>
    <div class="tab-box">
      <div v-if="!isFixed">
        <tab :tabList="tabList"
             :name="'tabone'"
             @onSwitch="tabChange"></tab>
      </div>
    </div>
    <div class="tab-box"
         v-if="isFixed"
         style="position:fixed;top:0;left:0;right:0;background:#FBFBFB;box-sizing:border-box;padding:0 12px;z-index:99999;">
      <tab :tabList="tabList"
           :name="'tabtwo'"
           @onSwitch="tabChangeTwo"
           ref="child"></tab>
    </div>

    <div class="tabelement">
      <card>
        <div class="column mt12"
             style="margin-top:2px;">
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'"
                     :textSize="14"
                     style="margin-right:6px;font-weight:700;font-family: PingFang SC,Arial,sans-serif;-webkit-font-smoothing: antialiased;">公司信息</rtext>
            </div>
          </div>
        </div>
        <rline></rline>
        <div @click="goListPage('/travelAgency/personnelinfo?id=legalRepresentative')">
          <listItem :label="'法定代表人'"
                    :labelWidth="128"
                    :ctnColor="'#333333'"
                    :showRight="true"
                    :textAlign="'right'">{{travelAgencyDetails.corporateRepresentative}}</listItem>
          <rline></rline>
        </div>

        <listItem :label="'统一社会信用代码'"
                  :labelWidth="128"
                  :ctnColor="'#333333'"
                  :showRight="false"
                  :textAlign="'right'">{{travelAgencyDetails.businessLicence}}</listItem>
        <rline></rline>
        <listItem :label="'经营许可证编号'"
                  :labelWidth="128"
                  :ctnColor="'#333333'"
                  :showRight="false"
                  :textAlign="'right'">{{travelAgencyDetails.licenceNum}}</listItem>
        <rline></rline>
        <div @click="goListPage('/travelAgency/registInfo')">
          <listItem :label="'注册信息'"
                    :labelWidth="128"
                    :ctnColor="'#CCCCCC'"
                    :textAlign="'right'">企业性质、注册资本</listItem>
          <rline></rline>
        </div>
        <div @click="goListPage('/travelAgency/manageInfo')">
          <listItem :label="'经营信息'"
                    :labelWidth="128"
                    :ctnColor="'#CCCCCC'"
                    :textAlign="'right'">业务范围、特色、等级</listItem>
          <rline></rline>
        </div>
        <div @click="goListPage('/travelAgency/otherInfo')">
          <listItem :label="'其他信息'"
                    :labelWidth="128"
                    :ctnColor="'#CCCCCC'"
                    :textAlign="'right'">固话、网站、保险公司</listItem>
        </div>
      </card>
    </div>

    <div class="tabelement">
      <card>
        <div class="column mt12"
             @click="memberList.length > 0 ? goListPage('/travelAgency/companyPerson?id=' + travelAgencyDetails.id) : ''">
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'"
                     :textSize="14"
                     style="margin-right:6px;font-weight:700;font-family: PingFang SC,Arial,sans-serif;-webkit-font-smoothing: antialiased;">公司职员</rtext>
            </div>
          </div>
          <right :title="'全部 '+ memberTotalPage +' 人'"
                 :rightShow="memberList.length > 0 ? true : false"
                 :txtColor="memberList.length > 0 ? '': '#999'"></right>
        </div>

        <div class="personal">
          <div class="item"
               v-for="(item,index) in memberList"
               :key="index"
               @click="goListPage('/travelAgency/personnelinfo?id=' + item.id)"
               v-show="index < 12">
            <img class="img"
                 src="@/assets/travelAgency/ic_bm_cy.png" />
            <div class="name">{{item.name}}</div>
            <div class="desc">{{item.type == 1 ? item.office : (item.type == 2 ? '紧急联系人' :(item.type == 3 ? '出资人' : (item.type == 4 ? '计调人员' : item.office)))}}</div>
          </div>
        </div>
      </card>
    </div>

    <div class="tabelement">
      <card>
        <div class="column mt12"
             @click="guideList.length > 0 ? goListPage('/travelAgency/tourGuide?id=' + travelAgencyDetails.id) : ''">
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'"
                     :textSize="14"
                     style="margin-right:6px;font-weight:700;font-family: PingFang SC,Arial,sans-serif;-webkit-font-smoothing: antialiased;">签约导游</rtext>
            </div>
          </div>
          <right :title="'全部 '+ guideTotalPage +' 人'"
                 :rightShow="guideList.length > 0 ? true : false"
                 :txtColor="guideList.length > 0 ? '': '#999'"></right>
        </div>
        <div class="personal">
          <!-- <div class="item"
               v-for="(item,index) in guideList"
               :key="index"
               v-show="index < 12"
               @click="goGuideDetail(item)"> -->
               <div class="item"
               v-for="(item,index) in guideList"
               :key="index"
               v-show="index < 12"
               >
               <img class="img"
                 src='../../assets/travelAgency/ic_bm_cy1.png' />
            <!-- <img class="img"
                 :src="item.photoPath? item.photoPath:'../../assets/travelAgency/ic_bm_cy1.png'" /> -->
            <div class="name">{{item.name}}</div>
            <div class="desc">{{item.guideTypeStr}}</div>
          </div>
        </div>
      </card>
    </div>

    <div class="tabelement">
      <card>
        <div class="column mt12"
             @click="travelPhoto.list.length > 0 ? goListPage('/travelAgency/documentPhoto?id=' + travelAgencyDetails.id) : ''">
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'"
                     :textSize="14"
                     style="margin-right:6px;font-weight:700;font-family: PingFang SC,Arial,sans-serif;-webkit-font-smoothing: antialiased;">证件图片</rtext>
            </div>
          </div>
          <right :title="'全部 ' + travelPhoto.count + ' 张 '"
                 :rightShow="travelPhoto.list.length > 0 ? true : false"
                 :txtColor="travelPhoto.list.length > 0 ? '': '#999'"></right>
        </div>
        <div class="img-list">
          <div class="item"
               v-for="(item,index) in travelPhoto.list"
               :key="index">
            <div class="imgs">
              <img class="img"
                   :src="item.photos[0]" />
              <div class="num">共{{item.photos.length}}张</div>
            </div>
            <div class="name">{{item.name}}</div>
          </div>
        </div>
      </card>
    </div>

    <div class="tabelement">
      <card>
        <div class="column mt12"
             @click="lineTripList.length > 0 ? goListPage('/travelAgency/travelItinerary?travelId='+ travelAgencyDetails.id) : ''">
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'"
                     :textSize="14"
                     style="margin-right:6px;font-weight:700;font-family: PingFang SC,Arial,sans-serif;-webkit-font-smoothing: antialiased;">行程单</rtext>
            </div>
          </div>
          <right :title="'全部 '+ lineTotalPage +' 条 '"
                 :rightShow="lineTripList.length > 0 ? true : false"
                 :txtColor="lineTripList.length > 0 ? '': '#999'"></right>
        </div>

        <!-- @click="goListPage('/travelAgency/tripDetail?tripId=' + item.teamNo)" -->
        <div v-for="(item,index) in lineTripList"
             :key="index"
             @click="goItineraryDetail(item.teamNo)"
             v-show="index < 3">
          <div class="info-list">
            <div class="title">
              <div class="name">{{item.routeName}}</div>
              <!-- transform: scale(0.5);transform-origin: left center; -->
              <div style="display:flex;">
                <smllabel :txtColor="'#FFFFFF'"
                          :bgColor="'#36B374'"
                          :borderColor="'#36B374'"
                          v-if="Date.parse(new Date()) < (Date.parse(item.teamEndDate))">正在出团</smllabel>
              </div>
            </div>
            <div class="desc">
              <div class="txt">{{item.teamStartDate && item.teamStartDate.substring(0,10)}} 至 {{item.teamEndDate && item.teamEndDate.substring(0,10)}} {{item.teamStartPlace}}</div>
            </div>
            <div class="desc">
              <div class="txt">行程单号: {{item.teamNo}}</div>
              <right :txtColor="'#36B374'"></right>
            </div>
          </div>
          <rline style="margin-bottom:16px"
                 v-if="index < 2"></rline>
        </div>
      </card>
    </div>

    <div class="tabelement">
      <card>
        <div class="column mt12"
             @click="compliantList.length > 0 ? goListPage('/travelAgency/complaintlList') : ''">
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'"
                     :textSize="14"
                     style="margin-right:6px;font-weight:700;font-family: PingFang SC,Arial,sans-serif;-webkit-font-smoothing: antialiased;">投诉</rtext>
            </div>
          </div>
          <right v-if="true"
                 :title="'全部 '+ (compliantTotalPage || 0) +' 条 '"
                 :rightShow="compliantList&&compliantList.length > 0 ? true : false"
                 :txtColor="compliantList&&compliantList.length > 0 ? '': '#999'"></right>
        </div>

        <div v-for="(item,index) in compliantList"
             :key="index"
             v-show="index < 3"
             @click="gocompliantDetail(item)">
          <div class="info-list">
            <div class="title">
              <div class="name">{{item.complain_problem}}</div>
            </div>
            <div class="desc">
              <div class="txt">{{item.complain_time && item.complain_time.substring(0,10)}}</div>
            </div>
            <div class="desc">
              <div class="txt">{{item.complain_classify}}</div>
              <right :txtColor="'#36B374'"
                     :title="item.subStatue"></right>
            </div>
          </div>
          <rline style="margin-bottom:16px"
                 v-if="index < 2"></rline>
        </div>
      </card>
    </div>

    <div class="tabelement">
      <card>
        <div class="column mt12">
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'"
                     :textSize="14"
                     style="margin-right:6px;font-weight:700;font-family: PingFang SC,Arial,sans-serif;-webkit-font-smoothing: antialiased;">游客评价</rtext>
            </div>
          </div>
          <right :title="'全部 '+ this.remarkPage.total +' 条 '"
                 :rightShow="false"
                 :txtColor="remarkList.length > 0 ? '': '#999'"></right>
        </div>
        <van-list v-model="loading"
                  :finished="finished"
                  :finished-text="finishedText"
                  @load="loadMore"
                  v-if="remarkList.length > 0">
          <div v-for="(item,index) in remarkList"
               :key="index">
            <div class="evaluate"
                 :class="{'mt16':index!=0}">
              <img class="img"
                   src="@/assets/travelAgency/ic_bm_cy.png" />
              <div class="wrap">
                <div class="username">{{item.name}}</div>
                <div class="cmt-time">
                  <div class="txt">{{item.ctime && item.ctime.substring(0,10)}}</div>
                  <div class="txt">来自游云南app</div>
                </div>
                <div class="score">
                  <div class="tit">打分</div>
                  <div class="star">
                    <van-rate v-model="item.score"
                              readonly
                              allow-half
                              size="8px"
                              gutter="2px"
                              color="#FF8C19"
                              void-color="#CCCCCC"
                              void-icon="star" />
                  </div>
                </div>
                <div class="desc">{{item.opinion}}</div>
              </div>
            </div>
            <rline style="margin-top:16px "></rline>
          </div>
        </van-list>
        <div class="more-data"
             v-if="finished && Math.ceil(this.remarkPage.total / this.remarkPage.page_size) > 1 && parseInt(remarkPage.current_page) === 1">下滑加载更多</div>
      </card>
    </div>
    <!-- <div class="footerbtn" v-if="originCityId != '34' && travelAgencyDetails.state == 1">
      <div class="btn-cancel" @click="onNoPass">审核不通过</div>
      <div class="btn-ok" @click="onPass">审核通过</div>
    </div> -->
    <callPhone ref="callPhone" :combinPhone="combinPhone"></callPhone>
    <!-- 审核信息按钮 -->
    <div class="check_btn" v-if="travaRole.roleName == 'marketRegulationTravel-1' && travelAgencyDetails.state == '1'">
    <!-- <div class="check_btn"> -->
          <span class="s_btn" @click="$router.push(`/travelAgency/failPass?id=${id}&back=${back}`)">审核不通过</span>
          <span class="s_btn f_btn" @click="passBtn">审核通过</span>
    </div>
    <!-- 单项委托审核按钮 -->
    <div class="check_btn" v-if="relevanceId != null && relevanceId.length > 0">
          <span class="s_btn" @click="showDelegateReviewPannel = true">审核不通过</span>
          <span class="s_btn f_btn" @click="onTapPassDelegateReview">审核通过</span>
    </div>
    <!-- 单项委托审核意见弹窗 -->
    <van-popup v-model="showDelegateReviewPannel"
               round
               position="bottom">
               <div class="review-pannel">
                <!-- 标题 -->
                <p class="title">单项委托审批</p>
                <div class="separator"></div>
                <!-- 关闭 -->
                <div class="close-box" @click="showDelegateReviewPannel = false">
                  <img src="../../assets/common/arrow_down@2x.png"
                          alt
                          class="arrow-img" />
                </div>
                <textarea class="review-input" placeholder="请输入审核不通过的批复意见" v-model="inputValue" />
                <!-- 按钮 -->
                <div class="btn-box">
                  <div class="btn-border" @click="showDelegateReviewPannel = false">取消</div>
                  <div :class="inputValue.length > 0 ? 'btn-primary' : 'btn-primary disable'" @click="onTapRejectDelegateReview">驳回</div>
                </div>
               </div>
    </van-popup>
  </div>
</template>
<script>
    import tab from './components/tab-event';
    import rtext from './components/text';
    import listItem from './components/list-itemone';
    import card from './components/card';
    import rline from './components/line';
    import checkedTag from './components/checked-tag';
    import right from './components/right';
    import txtTag from './components/txt-tag';
    import api from '../../service/modules/travel';
    import apig from "../../service/modules/guide";
    import { Toast } from 'vant';
    import callPhone from 'comps/callPhone';
    import mixin from '@/mixins/index';
    import smllabel from './components/small-label'
    import apimessage from '../../service/modules/message'
    import util from '@/utils/common';
    import { navigateToItineraryUniversal } from '@/router/navigate';

    export default {
        components: {
            rtext,
            card,
            checkedTag,
            right,
            txtTag,
            rline,
            listItem,
            tab,
            callPhone,
            smllabel
        },
        mixins: [mixin],
        data () {
            return {
                // 'guideInfoObj')).roleName
                travaRole: util.getJsonLocal('guideInfoObj') || {
                  OrgInfo: {
                    orgRegionType: ''
                  }
                },
                id: this.$route.query.id,
                cityColumns: [],
                combinPhone: '0',
                tabList: ['信息', '职员', '导游', '图片', '行程单', '投诉', '评价'],
                tag: ['分社', '昆明市 五华区 石林县'],
                phoneShow: false,
                topList: [],
                tabHeight: '',
                scrollHeight: '',
                isFixed: false,
                active: '',
                practitioners: {},
                travelAgencyDetails: {},
                signingGuideList: {},
                isLoadOver: false,
                loading: false,
                finished: false,
                finishedText: '没有更多',
                remarkPage: { total: 0, current_page: 0, page_size: 10 },
                remarkList: [],
                complaintMessage: {},
                lineTripList: [],
                travelBlackList: [],
                createTime: '',
                leftTime: '',
                disciplineCreatTime: '',
                disciplineLeftTime: '',
                blackList: [],
                disciplineList: [],
                lineTotalPage: 0,
                compliantList: [],
                compliantTotalPage: 0,
                integrityIndex: null,
                memberTotalPage: 0,
                memberList: [],
                guideTotalPage: 0,
                guideList: [],
                cityAllList: [],
                clickActive: '',
                travelPhoto: {
                    count: 0, // 所有图片总数
                    list: [] // 图片列表
                },
                pageLoadOver: {
                    member: false,
                    guide: false,
                    photo: false,
                    trip: false,
                    compliant: false,
                    review: false,
                    gradeindex: false,
                    blacklist: false,
                    disciplinelist: false,
                    supervisedetail: false
                },
                isShouldScroll: 'hidden',
                originCityId: '',
                superviseData: {},
                travelInfoScrollDiatance: 0,
                back: this.$route.query.back || '',
                agencyType: ['', '总社', '分社', '网点'],
                // 审核相关
                type: this.$route.query.type,
                relevanceId: this.$route.query.relevanceId,
                delegateContent: '',
                showDelegateReviewPannel: false,
                inputValue: ''
            };
        },

        computed: {
            contacts () {
                return this.$store.getters['home/contactsList']
            }
        },

        watch: {
            // 监听相关的6个接口是否加载完毕，以获取每个模块的高度
            pageLoadOver: {
                handler (newName, oldName) {
                    if (newName.compliant && newName.guide && newName.member && newName.photo && newName.trip && newName.gradeindex && newName.blacklist && newName.disciplinelist && newName.supervisedetail) {
                        this.$nextTick(res => {
                            this.getElement();
                            this.isShouldScroll = 'auto'
                        })
                    }
                },
                deep: true,
                immediate: true
            }

        },
        activated () {

            // this.reset();
        },
        beforeMount() {
          this.getGuideContent()
          console.log('travel role = ', this.travaRole)
        },
        mounted () {
            this.reset();
        },
        methods: {
          getGuideContent(type = 'GUIDE') {
            // 获取导率用户权限
            apig.getUser(type).then(res => {
              if (res.ret === 0) {
                let guideInfo = res.data;
                if (res.data) {
                  this.travaRole = res.data;
                }
                localStorage.setItem("guideInfoObj", JSON.stringify(guideInfo));
              }
            });
          },
            // 审核通过
            passBtn () {
                api.auditYesTravel({ travelId: this.id }).then(res => {
                    if (res.ret === 0) {
                        this.$Toast.loading({
                            message: '审核通过',
                            icon: 'passed',
                            forbidClick: true
                        });
                        this.reset();
                    }
                });
            },
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id)
                    })
                }
            },
            // 电话弹窗
            onPhoneShow () {
                this.call({ mobile: this.travelAgencyDetails.telephone, name: this.travelAgencyDetails.name })
                this.combinPhone = this.travelAgencyDetails.telephone;
                this.$refs.callPhone.showBox();
            },
            // 列表页跳转
            goListPage (val) {
                this.storageScroll()
                this.$router.push(`${val}`)
            },
            // 将travelInfoScrollDiatance本地存储起来
            storageScroll () {
                localStorage.travelInfoScrollDiatance = this.travelInfoScrollDiatance
            },
            // 跳转重点监督页面
            goSuperviseDetail () {
                this.storageScroll()
                console.log(`${this.globalApp.getSystemInfo().host}web/#/integrity/supervisionDetails?isFromTravel=1&supervisionId=${this.superviseData.supervisionId}&enterpriseId=${this.superviseData.enterpriseId}`)
                window.yyn.invokeJSB(
                    'openWindow', {
                        openUrl: `${this.globalApp.getSystemInfo().host}web/#/integrity/supervisionDetails?isFromTravel=1&supervisionId=${this.superviseData.supervisionId}&enterpriseId=${this.superviseData.enterpriseId}`,
                        isFullScreen: 0,
                        setTitle: '',
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
            },
            // 跳转投诉详情页
            gocompliantDetail (item) {
                this.$store.commit('complaint/setHandleWorkbench', false);
                this.storageScroll()
                console.log(`${this.globalApp.getSystemInfo().host}web/#/complaint/detailList/complaintSheet`)
                localStorage.setItem('item', JSON.stringify(item))
                setTimeout(() => {
                    window.yyn.invokeJSB(
                        'openWindow', {
                            openUrl: `${this.globalApp.getSystemInfo().host}web/#/complaint/detailList/complaintSheet`,
                            isFullScreen: 0,
                            setTitle: '',
                            needLoading: 1
                        },
                        cb => {
                            console.log(cb, 'callback');
                        }
                    );
                }, 300)
            },
            // 跳转导游详情页
            goGuideDetail (items) {
                this.storageScroll()
                window.yyn.invokeJSB(
                    'openWindow', {
                        openUrl: `${this.globalApp.getSystemInfo().host}web/#/guide/info?guideId=${items.id}&isBlacklist=${items.isBlacklist}&isSupervise=${items.isSupervise}`,
                        isFullScreen: 0,
                        setTitle: '',
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
            },
            tabChange (idx) {
                document.querySelector('.agencyinfo').scrollTop = this.topList[idx] - 50;
                this.clickActive = idx
                console.log('非固定点击idx' + idx)
            },
            tabChangeTwo (idx) {
                document.querySelector('.agencyinfo').scrollTop = this.topList[idx] - 50;
                this.clickActive = idx
            },
            getElement () {
                if (localStorage.travelInfoScrollDiatance) {
                    document.querySelector('.agencyinfo').scrollTop = localStorage.travelInfoScrollDiatance
                    localStorage.removeItem('travelInfoScrollDiatance')
                }
                let topList = [];
                this.tabHeight = document.querySelector('.data-card-tab').clientHeight;
                this.scrollHeight = document.querySelector('.data-card-tab').offsetTop;
                for (var i = 0; i < document.querySelectorAll('.tabelement').length; i++) {
                    topList.push(document.querySelectorAll('.tabelement')[i].offsetTop);
                }
                this.topList = topList;
            },
            scroll (e) {
                let { scrollTop } = e.target;
                if (localStorage.travelInfoScrollDiatance) {
                    document.querySelector('.agencyinfo').scrollTop = localStorage.travelInfoScrollDiatance
                    localStorage.removeItem('travelInfoScrollDiatance')
                }
                this.travelInfoScrollDiatance = scrollTop
                if (scrollTop > parseInt(this.scrollHeight) && (this.pageLoadOver.compliant && this.pageLoadOver.guide && this.pageLoadOver.member && this.pageLoadOver.photo && this.pageLoadOver.review && this.pageLoadOver.trip)) {
                    // 显示吸顶导航栏
                    this.isFixed = true;
                    var active = 0;
                    if (this.topList && this.topList.length > 0) {
                        for (let i = 0; i < this.topList.length; i++) {
                            if (this.topList[i] >= scrollTop) {
                                active = i >= 0 ? i : 0;
                                break;
                            } else if (this.topList[i] < scrollTop) {
                                active = this.topList.length - 1;
                            } else {
                                active = 0;
                            }
                        }
                        if ((parseInt(this.clickActive) === 0 || this.clickActive) && this.clickActive != active) {
                            if (this.$refs.child) {
                                // 根据active来显示对应的tab激活状态
                                this.$refs.child.switchTab(this.clickActive);
                                this.clickActive = ''
                                return false;
                            }
                        }
                        this.$nextTick(() => {
                            if (this.$refs.child) {
                                // 根据active来显示对应的tab激活状态
                                this.$refs.child.switchTab(active);
                            }
                        })
                    }
                } else {
                    this.isFixed = false;
                }
            },
            // 获取初始数据
            getInitData () {
                api.getTravelDetail({ id: this.id }).then(res => {
                    if (res.ret === 0) {
                        this.isLoadOver = true;
                        let {
                            travelAgencyDetails
                        } = res.data;
                        // this.travelAgencyDetails = travelAgencyDetails;
                        this.travelAgencyDetails = res.data;
                        // this.combinPhone = this.travelAgencyDetails.telephone;
                        localStorage.travelDetail = JSON.stringify(res.data);
                        // this.getGradeIndex()
                        localStorage.removeItem('travelMemberList')
                        localStorage.removeItem('blackList')
                        localStorage.removeItem('disciplineList')
                        if (res.data.isBlacklist != 0) {
                            this.getBlackList();
                        } else {
                            this.$set(this.pageLoadOver, 'blacklist', true)
                        }
                        this.getDisciplineList();
                        if (res.data.isSupervise) {
                            this.getTreavelSuperviseDetail()
                        } else {
                            this.$set(this.pageLoadOver, 'supervisedetail', true)
                        }
                        this.getTravelCityAll()
                        this.getMemberList()
                        this.getGuideList()
                        this.getTreavelPhotoList()
                        this.getTripList()
                        // this.getComplaintList()
                        this.getPreviewList()
                    }
                });
            },
            // 诚信指数评分
            getGradeIndex () {
                api.getGradeIndex({ creditCode: this.travelAgencyDetails.businessLicence }).then(res => {
                    if (res.ret === 0) {
                        this.integrityIndex = res.data
                    }
                    this.$set(this.pageLoadOver, 'gradeindex', true)
                })
            },
            // 黑名单监管中
            getBlackList () {
                api.getBlackList({ travelId: this.travelAgencyDetails.id }).then(res => {
                    if (res.ret === 0) {
                        let blackList = res.data;
                        blackList.map((items, index) => {
                            if (items.recordState === 1) {
                                this.createTime = items.createTime;
                                this.leftTime = items.leftTime;
                            }
                        });
                        this.blackList = res.data
                        localStorage.blackList = JSON.stringify(res.data);
                    }
                    this.$set(this.pageLoadOver, 'blacklist', true)
                });
            },
            // 黑名单监管中（全国惩戒）
            getDisciplineList () {
                api.getDisciplineList({ travelId: this.travelAgencyDetails.id })
                    .then(res => {
                        if (res.ret === 0) {
                            localStorage.disciplineList = JSON.stringify(res.data);
                        }
                        this.$set(this.pageLoadOver, 'disciplinelist', true)
                    });
            },
            // 企业重点关注详情
            getTreavelSuperviseDetail () {
                api.getTreavelSuperviseDetail({ creditCode: this.travelAgencyDetails.businessLicence }).then(res => {
                    console.log(res)
                    if (res.ret === 0) {
                        this.superviseData = res.data
                    }
                    this.$set(this.pageLoadOver, 'supervisedetail', true)
                })
            },
            // 拉取所有市和县的数据
            getTravelCityAll () {
              api.getTravelCityAll().then(res => {
                    if (res.ret === 0) {
                        this.cityAllList = res.data.list
                    }
                })
            },
            // 公司职员列表
            getMemberList () {
                api.getMemberList({ p: 1, travelId: this.travelAgencyDetails.id }).then(res => {
                    if (res.ret === 0) {
                        this.memberList = res.data.list
                        this.travelMemberList = res.data.list
                        this.memberTotalPage = res.data.pagination.total
                        if (this.travelAgencyDetails.corporateRepresentative) {
                            // 法定代表人
                            let obj = {
                                id: 'legalRepresentative',
                                name: this.travelAgencyDetails.corporateRepresentative,
                                office: this.travelAgencyDetails.legalRepresentativePost,
                                organization: this.travelAgencyDetails.legalRepresentativeDepartment,
                                sexStr: this.travelAgencyDetails.legalRepresentativeSex,
                                nation: this.travelAgencyDetails.legalRepresentativeNation,
                                idcard: this.travelAgencyDetails.crIdNum,
                                phone: this.travelAgencyDetails.crPhone
                            }
                            let arr = []
                            arr.push(obj)
                            this.travelMemberList = [...this.travelMemberList, ...arr]
                        }
                        localStorage.travelMemberList = JSON.stringify(this.travelMemberList)
                    }
                    this.$set(this.pageLoadOver, 'member', true)
                })
            },
            // 签约导游列表
            getGuideList () {
                api.getGuideList({ p: 1, travelId: this.travelAgencyDetails.id }).then(res => {
                    if (res.ret === 0) {
                        this.guideTotalPage = res.data.pagination.total
                        this.guideList = res.data.list
                    }
                    this.$set(this.pageLoadOver, 'guide', true)
                })
            },
            // 证件照片列表
            getTreavelPhotoList () {
                let list = []
                let count = 0
                let photo = []
                if (!this.travelAgencyDetails.appendinx) {
                    this.travelPhoto = { count: count, list: list }
                    this.$set(this.pageLoadOver, 'photo', true)
                    localStorage.setItem('travelPhoto', JSON.stringify(this.travelPhoto.list))
                    return
                }
                if (this.travelAgencyDetails.appendinx.businessLicensePhoto) {
                    photo = this.travelAgencyDetails.appendinx.businessLicensePhoto.split(',')
                    list.push({ name: '营业执照', photos: photo })
                    console.log(photo.length)
                    count += photo.length
                }
                if (this.travelAgencyDetails.appendinx.businessPlacePhoto) {
                    photo = this.travelAgencyDetails.appendinx.businessPlacePhoto.split(',')
                    list.push({ name: '营业场所证明材料', photos: photo })
                    count += photo.length
                }
                if (this.travelAgencyDetails.appendinx.crRecord) {
                    photo = this.travelAgencyDetails.appendinx.crRecord.split(',')
                    list.push({ name: '法定代表人履历', photos: photo })
                    count += photo.length
                }
                if (this.travelAgencyDetails.appendinx.incorporationArticlesPhoto) {
                    photo = this.travelAgencyDetails.appendinx.incorporationArticlesPhoto.split(',')
                    list.push({ name: '企业章程', photos: photo })
                    count += photo.length
                }
                if (this.travelAgencyDetails.appendinx.corporateIdcardPhoto) {
                    photo = this.travelAgencyDetails.appendinx.corporateIdcardPhoto.split(',')
                    list.push({ name: '法定代表人身份证正反面', photos: photo })
                    count += photo.length
                }
                if (this.travelAgencyDetails.appendinx.businessCertificatePhoto) {
                    photo = this.travelAgencyDetails.appendinx.businessCertificatePhoto.split(',')
                    list.push({ name: '旅行社业务经营许可证副本', photos: photo })
                    count += photo.length
                }
                if (this.travelAgencyDetails.appendinx.officeDevicePhoto) {
                    photo = this.travelAgencyDetails.appendinx.officeDevicePhoto.split(',')
                    list.push({ name: '办公场所及设备证明材料', photos: photo })
                    count += photo.length
                }
                if (this.travelAgencyDetails.appendinx.policyPhoto) {
                    photo = this.travelAgencyDetails.appendinx.policyPhoto.split(',')
                    list.push({ name: '旅行社责任保险单', photos: photo })
                    count += photo.length
                }
                this.travelPhoto = { count: count, list: list }
                localStorage.setItem('travelPhoto', JSON.stringify(this.travelPhoto.list))
                this.$set(this.pageLoadOver, 'photo', true)
                // api.getTreavelPhotoList({ p: 1, pageSize: 20, travelId: this.travelAgencyDetails.id }).then(res => {
                //     if (res.ret === 0) {
                //         if (res.data) {
                //             this.travelPhoto = res.data
                //         }
                //     }
                //     this.$set(this.pageLoadOver, 'photo', true)
                // })
            },
            // 行程单列表
            getTripList () {
                api
                    .traveltripList({ travelId: this.travelAgencyDetails.id })
                    .then(res => {
                        if (res.ret === 0) {
                            this.lineTripList = res.data.list;
                            this.lineTotalPage = res.data.pagination.total
                        }
                        this.$set(this.pageLoadOver, 'trip', true)
                    });
            },
            // 投诉列表
            getComplaintList () {
                api.getComplaintList({ p: 1, pageSize: 10, name: this.travelAgencyDetails.name }).then(res => {
                    if (res.ret === 0) {
                        this.compliantList = res.data.list
                        this.compliantTotalPage = res.data.totalSize
                    }
                    this.$set(this.pageLoadOver, 'compliant', true)
                })
            },
            // 评论列表
            getPreviewList () {
                api
                    .getTravelPreviewList({
                        cardNo: this.travelAgencyDetails.licenceNum,
                        p: parseInt(this.remarkPage.current_page) + 1,
                        size: 20,
                        type: ''
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.remarkPage = res.data.pagination;
                            this.remarkList = [...this.remarkList, ...res.data.list];
                            this.loading = false;
                            if (
                                this.remarkPage.current_page >= Math.ceil(this.remarkPage.total / this.remarkPage.page_size)
                            ) {
                                this.finished = true;
                            }
                        }
                        this.$set(this.pageLoadOver, 'review', true)
                        // if (this.isShouldScroll === 'hidden') {
                        //     this.$set(this.pageLoadOver, 'review', true)
                        // }
                    });
            },
            // 评论列表加载更多
            loadMore () {
                this.getPreviewList();
            },
            // 获取单项委托信息
            fetchDelegateDetail () {
              api.getApplyDetail({ applyId: this.relevanceId})
                  .then(res => {
                    if (res.ret === 0) {
                      this.delegateContent = res.data.cmt
                    }
                  })
            },
            // 审核不通过
            onNoPass () {
                api
                    .travelOnNoPass({ id: this.travelAgencyDetails.id })
                    .then(res => {
                        if (res.ret === 0) {
                            Toast({
                                message: '审核不通过',
                                icon: 'https://images-1254950508.cos.ap-guangzhou.myqcloud.com/tr_false.png'
                            });
                            this.getInitData()
                        }
                    });
            },
            // 审核通过
            onPass () {
                api.travelOnPass({ id: this.travelAgencyDetails.id }).then(res => {
                    if (res.ret === 0) {
                        Toast({
                            message: '审核通过',
                            icon: 'https://images-1254950508.cos.ap-guangzhou.myqcloud.com/tr_true.png'
                        });
                        this.getInitData()
                    }
                });
            },
            round (num, decimal) {
                if (isNaN(num)) {
                    return 0;
                }
                const p1 = Math.pow(10, decimal + 1);
                const p2 = Math.pow(10, decimal);
                return Math.round(num * p1 / 10) / p2;
            },

            toFixed (num, decimal) {
                return this.round(num, decimal).toFixed(decimal);
            },
            // 获取所有的市
            getAllCity () {
              api.getCity({ city: 34 }).then(res => {
                    if (res.ret === 0) {
                        let city = []
                        city.push({
                            value: '',
                            content: '云南省'
                        })
                        this.cityColumns = [...city, ...res.data.list]
                        this.getjurisdiction()
                    }
                });
            },
            // 地区权限 - getUser
            getjurisdiction () {
              const isGuide = JSON.parse(localStorage.getItem('systemPermissionList')).includes('GUIDE')
                api.getjurisdiction({ city: null, type: isGuide ? 'GUIDE':'' }).then(res => {
                    if (res.ret === 0) {
                        if (res.data.OrgInfo.orgRegionType === '1') {
                            // 省级

                            this.originCityId = '34'
                        } else if (res.data.OrgInfo.orgRegionType === '2') {
                            // 州市级
                            this.cityColumns[0].map((items, index) => {
                                if (items.value === res.data.OrgInfo.orgRegionId) {
                                    this.originCityId = res.data.OrgInfo.orgRegionId
                                }
                            })
                        }
                        localStorage.originCityId = this.originCityId
                    }
                })
            },
            reset () {
                let messageId = this.$route.query.messageId || ''
                let isRead = this.$route.query.isRead || 'true'
                this.onMessageReadOne(isRead, messageId)

                if (!localStorage.originCityId) {
                    this.getAllCity()
                }
                this.id = this.$route.query.id;
                this.getInitData();
                if (this.relevanceId != null && this.relevanceId.length > 0) {
                  // 从待办进入-需要获取审核信息
                  this.fetchDelegateDetail();
                }

                this.originCityId = localStorage.originCityId || ''
            },

            // 跳转单项委托审核记录页
            goDelegateReviewHistory () {
              this.$router.push({ path: '/travelAgency/reviewHistoryList', query: { travelId: this.id } })
            },
            onTapPassDelegateReview () {
              api.travelApplyAudit({
                applyId: this.relevanceId,
                status: 1,
              }).then(res=>{
                if (res.ret === 0) {
                    Toast({
                        message: '审核已通过',
                        icon: 'https://images-1254950508.cos.ap-guangzhou.myqcloud.com/tr_true.png'
                    });
                    this.relevanceId = null
                    this.getInitData()
                }
              })
            },
            // 点击单项委托审核 不通过
            onTapRejectDelegateReview () {
              if (this.inputValue == null || this.inputValue.length < 1) {
                return
              }
              api.travelApplyAudit({
                applyId: this.relevanceId,
                status: -1,
                cmt: this.inputValue
              }).then(res=>{
                if (res.ret === 0) {
                  this.showDelegateReviewPannel = false
                  Toast({
                      message: '批复意见已提交',
                      icon: 'https://images-1254950508.cos.ap-guangzhou.myqcloud.com/tr_true.png'
                  });
                  this.relevanceId = null
                  this.getInitData()
                }
              })
            },
            goItineraryDetail(id) {
              navigateToItineraryUniversal(id, 'team-supervision')
            }
        }

    };
</script>
<style scoped lang="less">
.container {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 12px;
  padding-bottom: 80px;
  background-color: #f0f2f5;

  .detail-box {
    .delegate-box {
      background-color: #fff;
      border-radius: 4px;
      margin-bottom: 10px;
      padding-left: 14px;
      padding-right: 14px;
      padding-top: 12px;
      padding-bottom: 23px;
      .title {
        font-size: 18px;
        font-weight: 500;
        color: #1e2226;
      }
      .sub-title {
        font-size: 14px;
        font-weight: 500;
        color: #1e2226;
        margin-top: 9px;
      }
      .content {
        margin-top: 5px;
        font-size: 14px;
        font-weight: 400;
        color: #54565c;
      }
    }
    .delegate-history-box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 56px;
      border-radius: 4px;
      background-color: #fff;
      align-items: center;
      padding-left: 16px;
      padding-right: 12px;
      margin-bottom: 20px;
      .title-box {
        display: flex;
        flex-direction: row;
        .icon {
          width: 16px;
          height: 16px;
        }
        .title {
          font-size: 16px;
          color: #1e2226;
          margin-left: 7px;
        }
      }
      .arrow-icon {
        width: 14px;
        height: 14px;
      }
    }
    .state-box {
      position: relative;
      display: flex;
      padding-bottom: 14px;
      .state-text {
        font-size: 14px;
        color: #54565c;
      }
      .state-item-box {
        background-color: #fff;
        border-radius: 4px;
        padding: 8px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 6px;
        .icon {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
      .permission-box {
        position: absolute;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 28px;
        padding: 0 14px;
        background-color: #fff;
        border-radius: 4px 4px 0 0;
        .permission-value {
          font-size: 12px;
          font-weight: 500;
        }
        .green {
          color: #36b374;
        }
        .red {
          color: #ef5948;
        }
        .blue {
          color:#1673d3
        }
        .orange {
          color: #ef750a;
        }
      }
    }
    .info-box {
      padding: 16px;
      background-color: #fff;
      .agency-name-box {
        display: flex;
        .agency-logo {
          width: 48px;
          height: 48px;
        }
        .name-box {
          display: inline;
          margin-left: 12px;
          .name-text {
            vertical-align: middle;
            font-size: 18px;
            color: #1e2226;
            font-weight: 600;
          }
          .gray-tag {
            display: inline-block;
            vertical-align: middle;
            border-radius: 2px;
            border: 0.5px solid #71747a;
            padding: 2px 4px;
            font-size: 12px;
            color: #71747a;
            margin-left: 4px;
          }
          .blue-tag {
            display: inline-block;
            vertical-align: middle;
            border-radius: 2px;
            border: 0.5px solid #67ABF2;
            padding: 2px 4px;
            font-size: 12px;
            color: #67ABF2;
            margin-left: 4px;
          }
        }
      }
      .separator {
        height: 1px;
        background-color: #f1f2f5;
        margin-top: 16px;
      }
      .items-box {
        position: relative;
        display: flex;
        flex-direction: column;
        .icon_phone {
          position: absolute;
          right: 0;
          top: 8px;
          width: 22px;
          height: 22px;
        }
        .info-item-box {
          display: flex;
          margin-top: 12px;
          .title {
            font-size: 14px;
            color: #1e2226;
          }
          .content {
            font-size: 14px;
            color: #71747a;
          }
        }
      }
    }
  }
  .footerbtn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
    box-sizing: border-box;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;

    .btn-cancel,
    .btn-ok {
      width: 165px;
      height: 40px;
      background: rgba(54, 179, 116, 1);
      border-radius: 3px;
      font-size: 17px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      text-align: center;
    }
    .btn-cancel {
      background: #fff;
      border-radius: 3px;
      border: 1px solid rgba(54, 179, 116, 1);
      color: rgba(54, 179, 116, 1);
    }
  }
  .check_btn {
    width: 100%;
    height: 60px;
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    box-sizing: border-box;
    .s_btn {
      width: 165px;
      height: 40px;
      display: inline-block;
      text-align: center;
      line-height: 40px;
      border: 1px solid #36b374;
      border-radius: 3px;
      font-size: 17px;
      color: #36b374;
    }
    .f_btn {
      background-color: #36b374;
      color: #fff;
    }
  }
  .phone-box {
    width: 260px;
    height: 144px;
    background: rgba(255, 255, 255, 1);
    border-radius: 3px;
    box-sizing: border-box;
    padding: 0 16px 16px 16px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;

    .phone {
      font-size: 18px;
      font-family: PingFang SC, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 90px;
      text-align: center;
    }
    .btn-box {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn-cancel,
      .btn-ok {
        width: 110px;
        height: 38px;
        border-radius: 2px;
        border: 1px solid rgba(204, 204, 204, 1);
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 38px;
      }
      .btn-ok {
        background: #36b374;
        color: #fff;
        border: none;
      }
    }
  }
  .head {
    padding-top: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .head-tag {
      display: flex;
    }
    .write {
      width: 64px;
      height: 28px;
      background: rgba(54, 179, 116, 1);
      border-radius: 1px;
      line-height: 28px;
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      color: #fff;
      margin-left: 8px;
    }
  }
  .tab-box {
    height: 50px;
  }

  .company {
    margin-top: 14px;

    .info {
      display: flex;
      justify-content: space-between;
      padding: 24px 16px 16px;
      box-sizing: border-box;

      .title {
        .tit {
          width: 225px;
          font-size: 20px;
          font-family: PingFang SC, Arial, sans-serif;
          -webkit-font-smoothing: antialiased;
          font-weight: 700;
          color: rgba(51, 51, 51, 1);
          line-height: 30px;
          margin-bottom: 12px;
        }
      }

      .img {
        width: 84px;
        height: 84px;
        background: url(../../assets/travelAgency/ic_Bitmap.png);
        border-radius: 3px;
        border: 1px solid rgba(238, 238, 238, 1);
        background-size: auto 100%;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        box-sizing: border-box;
        .wait {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 18px;
          background-color: #36b374;
          text-align: center;
          line-height: 18px;
          color: #fff;
          border-radius: 0 0 3px 3px;
          font-size: 0;
          span {
            display: inline-block;
            font-size: 11px;
            transform: scale(0.9);
            margin-top: 1px;
          }
        }
      }
    }
  }

  .column {
    height: 46px;
    display: flex;
    align-items: center;
    padding: 11px 16px;
    box-sizing: border-box;
    justify-content: space-between;

    .title {
      display: flex;
      align-items: center;

      .name {
        display: flex;
        align-items: center;

        .score-box {
          font-size: 16px;
          font-family: PingFang SC, Arial, sans-serif;
          -webkit-font-smoothing: antialiased;
          font-weight: 700;
          color: rgba(54, 179, 116, 1);
          line-height: 24px;
        }
      }
    }
  }

  .personal {
    display: flex;
    overflow: scroll;

    .item {
      margin-left: 16px;
      margin-right: 16px;
      position: relative;
      width: 36px;
      height: 95px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .img {
        width: 36px;
        height: 36px;
        object-fit: cover;
        border: 1px solid #eee;
      }

      .name {
        position: absolute;
        width: 60px;
        top: 40px;
        left: 50%;
        height: 28px;
        transform: translateX(-50%);
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .desc {
        position: absolute;
        width: 60px;
        top: 68px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
  }

  .img-list {
    display: flex;
    overflow: scroll;

    .item {
      margin-right: 13px;
      position: relative;
      width: 124px;
      height: 163px;
      display: flex;
      flex-direction: column;
      align-items: center;
      &:first-child{
        margin-left: 16px;
      }

      .imgs {
        position: relative;
        width: 124px;
        height: 124px;
        border-radius: 3px;

        .img {
          width: 100%;
          height: 100%;
          border-radius: 3px;
        }

        .num {
          position: absolute;
          width: 57px;
          height: 27px;
          right: 0;
          bottom: 0;
          padding: 4px 10px;
          box-sizing: border-box;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 3px 0px 0px 0px;
          font-size: 14px;
          font-family: PingFang SC, Arial, sans-serif;
          -webkit-font-smoothing: antialiased;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 20px;
        }
      }

      .name {
        position: absolute;
        width: 130px;
        top: 133px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
    }
  }

  .info-list {
    padding: 0 16px 10px 16px;

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-right: 16px;
      }
    }

    .desc {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .txt {
        margin-bottom: 4px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
  }

  .evaluate {
    display: flex;
    padding-left: 16px;
    padding-right: 16px;

    .img {
      width: 36px;
      height: 36px;
      margin-right: 12px;
    }

    .wrap {
      flex: 1;
      .username {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }

      .cmt-time {
        width: 100%;
        margin-top: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .txt {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
      }

      .score {
        margin-top: 4px;
        height: 16px;
        display: flex;
        align-items: center;
        .tit {
          margin-right: 4px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }

        .star {
          display: flex;
          align-items: center;
          height: 16px;
          .img {
            margin-right: 2px;
            width: 8px;
            height: 8px;
          }
        }
      }

      .desc {
        margin-top: 14px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }
    }
  }

  .more-data {
    height: 50px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    text-align: center;
    line-height: 50px;
  }
  .personal::-webkit-scrollbar {
    display: none;
  }
  .img-list::-webkit-scrollbar {
    display: none;
  }
}
.review-pannel {
  padding-top: 14px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 28px;
  display: flex;
  flex-direction: column;
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #171a1d;
    line-height: 22px;
    margin-bottom: 16px;
  }
  .close-box {
    position: absolute;
    right: 16px;
    top: 16px;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    .arrow-img {
      width: 16px;
      height: 16px;
    }
  }
  .review-input {
    min-height: 170px;
    background-color: #F5F7FA;
    font-size: 16px;
    color: #1e2226;
    outline: none;
    border: none;
    resize: none;
    padding: 12px;
    margin-bottom: 38px;
  }
  .btn-box {
    display: flex;
    .btn-border {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      color: #36b374;
      border-radius: 4px;
      border: 1px solid #36b374;
      width: 96px;
      height: 40px;
    }
    .btn-primary {
      display: flex;
      margin-left: 10px;
      justify-content: center;
      align-items: center;
      flex: 1;
      height: 40px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      background-color: #36b374;
      border-radius: 4px;
    }
    .disable {
      background-color: rgba(54, 179, 116, 0.4)
    }
  }
}
</style>
